import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { AppContext } from "../../../context";
import { PopoverInput } from "../../../components/PopoverInput";
import { BRANDS, MODES } from "../../../configs";

import styles from "./SovPassengerClassFieldInput.scss";

const ClassField = ({
	id, mode, className, selectedClass, classList, onChange
}) => {
	const [useAppState] = AppContext.useAppContext();
	const isMobileView = useAppState.brand === BRANDS.SOV && window.matchMedia("(max-width: 767px)").matches;
	const isStackMobileLayout = useAppState.brand === BRANDS.SOV && !useAppState.sovSimplifiedSearchBar;

	return (
		<PopoverInput
			id={id}
			mode={mode}
			label={useAppState.getDictionary("class")}
			brand={useAppState.brand}
			value={selectedClass?.label}
			defaultCloseIcon={false}
			className={cx(className, {
				[styles[useAppState.brand]]: styles[useAppState.brand],
			})}
			icon={
				<span className={styles.listViewButton} focus-trap-toggle="true">
					<FontAwesomeIcon
						icon={faChevronDown}
						className={styles.listViewIcon}
					/>
				</span>
			}
			onChange={onChange}
			reactDOM={useAppState.reactDOM}
			appRoot={useAppState.appRoot}
			onClose={()=> { 
				window.WEB_CDN_BSB._emitter.emit("widgetToggle", false);
				return !!selectedClass;
			}}
			>
			{({handleClose}) => (
				<fieldset className={cx(styles.container, {
					[styles.containerStackLayout]: isStackMobileLayout,
				})}>
					{isStackMobileLayout && isMobileView && 
						<div className={styles.classHeading}>
							<span>{useAppState.getDictionary("class")}</span>
						</div>}
					<div className={styles.classListContainer}>
						{classList?.map(list =>  (
							<button 
								type="button" 
								key={list.id}
								onClick={() => {
									handleClose();
									onChange(list)
								}}
								className={cx(styles.classListItem, {
								[styles.classListItemselected]: selectedClass.label === list.label,
							})}>
								{list.label}
							</button>
						))}
					</div>
				</fieldset>
			)}
		</PopoverInput>
	);
};

ClassField.propTypes = {
	id: PropTypes.string,
	mode: PropTypes.string,
	className: PropTypes.string,

	classList: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.string,
	})).isRequired,
	selectedClass: PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.string,
	}).isRequired,
	onChange: PropTypes.func.isRequired,
};

ClassField.defaultProps = {
	id: undefined,
	mode: MODES.SEARCH,
	className: undefined,
};

export default ClassField;
export { ClassField };
